import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import PanelDev from '../panels/dev/PanelDev';
import PanelOverview from 'panels/home/PanelOverview';

export default function LayoutHome() {

    const [isOpen, setIsOpen] = useState(true);

    const { page } = useParams();

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    }

    return (
        <>
            <div className='h-screen w-full'>
                {
                    (() => {
                        switch (page) {
                            case 'main':
                                return (<PanelOverview onToggle={toggleMenu} />);
                            default:
                                return (<PanelDev />);
                        }
                    })()
                }
            </div>
        </>
    )
}
